<mat-checkbox class="mat-option all-option left-padding"
              [indeterminate]="isIndeterminate()"
              [checked]="isChecked()"
              (click)="$event.stopPropagation()"
              (change)="onChange($event)">
    {{ text }}
</mat-checkbox>
